import React from 'react';
import Microapp from '@/components/micro-app';
import env from '@/env';

export default () => {
  return <Microapp url={`${env.MC_DOMAIN}/dist/pages/help/myTools`} name="tbTool" />;
};
